module.exports = __webpack_public_path__ + "img/xmzt_2.62f38f2c.png";